
// ===================================
//         CVP jQuery Plugin
// ===================================


;(function($, doc, win, undefined)
{
    'use strict';

    function getPlayerType(agent)
    {
        return (/\b(Kindle|Fire|Silk|Android)\b/ig.test(agent)) ? CVP.HTML5 : CVP.FLASH;
    }

    var playerType = getPlayerType(win.navigator.userAgent);

    var pluginName = 'cvp',
        getDefaults = function()
        {
            return {
                id : undefined,
                width : 'auto',
                height : 'auto',
                // playerType : playerType,

                flashVars :
                {
                    context : 'ia',
                    autostart : 'off',
                    contentId: undefined,
                    
                    site : 'cnn', 
                    profile : '1',  
                    baseSwfUrl : 'http://z.cdn.turner.com/xslo/cvp/core/base/0/CVPBase.swf'
                },
                    
                embed :
                {
                    containerSwf : 'http://z.cdn.turner.com/xslo/cvp/assets/container/2.0.4.0/cvp_main_container.swf',
                    expressInstallSwf : 'http://z.cdn.turner.com/xslo/cvp/assets/flash/expressInstall.swf',
                    options :
                    {
                        quality : 'high',
                        bgcolor : '#000000',
                        allowFullScreen : 'true', 
                        allowScriptAccess : 'always',
                        wmode: "transparent"
                    }
                },

                onCVPReady : function()
                {
                    $(this).trigger('cvpReady');
                },

                onPlayerReady : function()
                {
                    if(this._playerType == "html5")
                    {
                        var contentId = this.getFlashVars().contentId;
                        var playerElement = $("#" + this.getId());

                        setTimeout($.proxy(function() {
                            this.content_entry = eval('(' + this.getContentEntry(contentId).toString() + ')');
                            playerElement.attr({'src' : playerElement.attr("src") + "?seed=" + Math.random() });
                            playerElement.attr({'preload' : "none"});
                            playerElement.attr({'type' : "video/mp4" });
                            playerElement.attr({'poster' : this.content_entry.images[0].image.text });

                        }, this), 1000);

                        playerElement.parents('.cvp-video').addClass('html5');
                    }
                    else
                    {
                        var player = this;
                        var playerObj = $(this.getDOMPlayer());
                        var playerCon = playerObj.parent();
                        var placeHolder = $("<img width='1920px' height='1080px' class='cvp-video--placeholder' src='<%= cdn %>media/assets/16-9-aspect.png'>");

                            playerCon.append(placeHolder);
                        
                        var resizeCVP = function()
                        {
                            if(playerCon.hasClass('cvp-video'))
                            {
                                playerObj.css({ width: placeHolder.width(), height: placeHolder.height() });
                                player.resize(playerObj.width(), playerObj.height());

                                if(playerCon.hasClass('fullscreen'))
                                {
                                    playerObj.css(
                                    {
                                        top: ($(win).height() / 2) - (playerObj.height() / 2),
                                        left: ($(win).width() / 2) - (playerObj.width() / 2)
                                    });
                                }
                            }
                        }

                        $(win).on('resize', function(e)
                        {
                            resizeCVP();
                        });

                        // An awful hack, but a needed one.
                        
                        for(var i = 0; i < 5; i++)
                        {
                            setTimeout(function() { resizeCVP() }, 250 * i);
                        }

                        resizeCVP();
                    }

                    $(this).trigger('cvpPlayerReady');
                },

                onContentBegin : function(playerId, contentId)
                { 
                    this.loggedProgress = 0;
                    this.content_entry = eval('(' + this.getContentEntry(contentId).toString() + ')');
                    $(this).trigger('cvpContentBegin');
                }, 
                
                onContentPlay : function(playerId, contentId) 
                {
                    var obj = this.getDOMPlayer();

                    $.each($('.cvp-video').find('object'), function(id, val)
                    {
                        if(val != obj) val['pause']();
                    });

                    win.trackVideoEvent(this.content_entry, "cnnvideo-start", playerId);
                    $(this).trigger('cvpContentPlay');
                },

                onContentPause : function(playerId, contentId, pause)
                {
                    if(!pause)
                    {
                        var obj = this.getDOMPlayer();

                        $.each($('.cvp-video').find('object'), function(id, val)
                        {
                            if(val != obj) val['pause']();
                        });
                    }
                    
                    win.trackVideoEvent(this.content_entry, "cnnvideo-pause", playerId);
                    $(this).trigger('cvpContentPause');
                },
                
                onContentComplete : function(playerId, contentId)
                {
                    win.trackVideoEvent(this.content_entry, "cnnvideo-complete", playerId);
                    $(this).trigger('cvpContentComplete');
                },
                
                onContentPlayhead : function(playerId, contentId, playhead, duration)
                {
                    $(this).trigger('cvpContentPlayhead');
                    
                    if( (typeof(jsmd) != "undefined") && (typeof(playhead) != "undefined") && (win.location.hostname != "edition.cnn.com"))
                    {
                        if(playhead > (duration * .75))
                        {
                            if(this.loggedProgress < (duration * .75))
                            {
                                win.trackVideoEvent(this.content_entry, "cnnvideo-seventyfive", playerId);
                                this.loggedProgress = (duration * .75);
                            }
                        }
                        else if(playhead > (duration * .5))
                        {
                            if(this.loggedProgress < (duration * .5))
                            {
                                win.trackVideoEvent(this.content_entry, "cnnvideo-fifty", playerId);
                                this.loggedProgress = (duration * .5);
                            }
                        }
                        else if(playhead > (duration * .25))
                        {
                            if(this.loggedProgress < (duration * .25))
                            {
                                win.trackVideoEvent(this.content_entry, "cnnvideo-twentyfive", playerId);
                                this.loggedProgress = (duration * .25);
                            }
                        }
                        else if(playhead > (duration * .1))
                        {
                            if(this.loggedProgress < (duration * .1))
                            {
                                win.trackVideoEvent(this.content_entry, "cnnvideo-ten", playerId);
                                this.loggedProgress = (duration * .1);
                            }
                        }
                    }
                },

                onContentBuffering : function(playerId, contentId, buffering)
                {
                    this.content_entry.buffering = buffering;
                    win.trackVideoEvent(this.content_entry, 'cnnvideo-buffer', playerId);
                    $(this).trigger('cvpContentBuffering');
                },

                onTrackingContentSeek : function(playerId, p_obj)
                {
                     win.trackVideoEvent(this.content_entry, 'cnnvideo-scrub', playerId);
                     $(this).trigger('cvpContentSeek');
                },

                onAdPlay : function(playerId, contentId)
                {
                    win.trackVideoEvent(this.content_entry, 'cnnvideo-preroll', playerId);
                },

                onAdEnd : function(playerId, contentId)
                {
                    win.trackVideoEvent(this.content_entry, 'cnnvideo-midroll-complete', playerId);
                }
            };

            version: "2.7.8.9"
        },

        methods = 
        {
            create : function(args)
            {
                $(this).data().cvp.create(args)
            },

            embed : function(args)
            {
                $(this).data().cvp.embed(args)
            },

            destroy : function(args)
            {
                $(this).data().cvp.destroy(args)
            },

            reset : function(args)
            {
                $(this).data().cvp.reset(args)
            },

            resize : function(args)
            {
                $(this).data().cvp.resize(args)
            }
        }

    // function jCVP( element, options )
    function jCVP( element, options )
    {
        options = options || {};

        this.element = element;
        this._defaults = getDefaults();
        this.options = $.extend( {}, this._defaults, options );
        this._name = pluginName;

        this.player = null;
        this.init();
    }

        jCVP.prototype =
        {
            init : function()
            {
                if(doc._jsmd) this.jsmd = new doc._jsmd.plugin.gCNNVideoCollection();
                this.createEventListeners();
                return this;
            },

            createEventListeners : function()
            {
                $(this.element).on('create', $.proxy(this.create, this));
                $(this.element).on('embed', $.proxy(this.embed, this));
                $(this.element).on('destroy', $.proxy(this.destroy, this));
                $(this.element).on('reset', $.proxy(this.destroy, this));
            },

            create : function()
            {
                if($(this.element).children().length > 0) this.destroy();

                // Create video player instance
                var cvp_html = $("<div class='poster'><img class='poster-img' src='" + $(this.element).attr('data-poster-src') + "'/><div class='play-button'><div class='icon'></div></div></div>")
                    .click($.proxy(this.onPosterClicked, this))
                    .add("<div id='" + $(this.element).attr('id') + "_player' class='player'></div>");

                $(this.element).append(cvp_html);
                return this;
            },

            embed : function()
            {
                if($(this.element).children().length > 0) this.destroy();

                // Create video player instance
                $(this.element).append($("<div id='" + $(this.element).attr('id') + "_player' class='player'></div>"));

                if(!this.player)
                {
                    if( typeof($(this.element).attr('id')) !== undefined) this.options.id = ($(this.element).attr('id') + "_cvp");
                    if( typeof($(this.element).attr('video-id')) !== undefined) this.options.flashVars.contentId = $(this.element).attr('video-id');

                    this.player = new CVP(this.options);
                }
                
                this.player.embedSWF( $(this.element).attr('id') + "_player" );
                return this;
            },

            onPosterClicked : function(e)
            {
                var el = $(e.target).parents('.poster');
                
                if(!el.hasClass('hide'))
                {
                    el.addClass('hide');
                    
                    if(!this.player)
                    {
                        if( typeof($(this.element).attr('id')) !== undefined) this.options.id = ($(this.element).attr('id') + "_cvp");
                        if( typeof($(this.element).attr('video-id')) !== undefined) this.options.flashVars.contentId = $(this.element).attr('video-id');

                        this.player = new CVP(this.options);
                    }
                    
                    this.player.embedSWF( $(this.element).attr('id') + "_player" );
                }

                $(this.element).trigger('cvpCreated');
            },

            destroy : function()
            {
                var p_id = $(this.element).attr('id') + "_cvp";
                CVP.unregisterInstance(p_id);
                
                if($(this.element).children().length > 0) $(this.element).html("");
                return this;
            },

            reset : function()
            {
                this.destroy();
                this.create();
                return this;
            }

            ,resize : function(w, h)
            {
                if(w != undefined && h != undefined)
                {
                    this.player.resize(w, h);
                }
                else
                {
                    this.player.resize($(this.element).width(), ($(this.element).width() * (9/16)) );
                }
            }

            ,getPlayer : function()
            {
                return this.player;
            }
        }


    $.fn[pluginName] = function ( options )
    {
        if(methods[options])
        {
            return this.each(function()
            {
                methods[ options ].apply( this, Array.prototype.slice.call( arguments, 1 ));
            });
        }
        else if ( typeof(options) === 'object' || !options)
        {
            return this.each(function ()
            {
                if (!$.data(this, pluginName))
                {
                    $.data(this, pluginName, new jCVP( this, options ));
                }
            });
        }
        else
        {
            $.error('jCVP does not support method : ' + options);
        }
    }

})(jQuery, document, window);